import { BaseRepository } from '../../infra/base.repository'
import { ConfigService } from '../../infra/config'
import type { OAuthAuthorizeCompleteDto } from './dto/oauth-authorize-complete.dto'

export class OAuthRepository extends BaseRepository<any> {
    constructor(
        config: ConfigService = new ConfigService(),
        token?: string,
        cache?: any,
    ) {
        super(config.userApiUrl + '/oauth', token, cache)
    }

    // Emite o authorization code (PKCE) para o usuário já autenticado — ver
    // components/account/users/oauth-authorize-page.svelte
    async authorizeComplete(dto: OAuthAuthorizeCompleteDto): Promise<{ redirectUri: string }> {
        const { json, statusCode, message } = await this.request.post(this.url + '/authorize/complete/?token=' + this.resolvedToken, dto)
        if (String(statusCode).substring(0, 1) === '2') return json
        throw message
    }
}
